import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams, HttpContext, HttpEvent, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class MyHttpClient {
    public debug = false;
    constructor(private http: HttpClient) {
        if (environment.production) {
            this.debug = false; // Disable debug in production
        }
    }

    get<T>(url: string, options?: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe?: 'body';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<T>;
    get(url: string, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe?: 'body';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<string>;
    get<T>(url: string, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'response';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpResponse<T>>;
    get(url: string, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'response';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpResponse<string>>;
    get<T>(url: string, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'events';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpEvent<T>>;
    get(url: string, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'events';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpEvent<string>>;
    get(url: string, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe?: 'body';
        reportProgress?: boolean;
        responseType: 'blob';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<Blob>;
    get<T>(url: string, options?: any): Observable<any> {
        if (this.debug) {
            console.warn('GET request to:', url, 'with options:', options);
        }
        return this.http.get<T>(url, options);
    }

    post<T>(url: string, body: any | null, options?: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe?: 'body';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<T>;
    post(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe?: 'body';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<string>;
    post<T>(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'response';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpResponse<T>>;
    post(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'response';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpResponse<string>>;
    post<T>(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'events';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpEvent<T>>;
    post(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'events';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpEvent<string>>;
    post<T>(url: string, body: any | null, options?: any): Observable<any> {
        if (this.debug) {
            console.warn('POST request to:', url, 'with body:', body, 'and options:', options);
        }
        return this.http.post<T>(url, body, options);
    }

    put<T>(url: string, body: any | null, options?: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe?: 'body';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<T>;
    put(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe?: 'body';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<string>;
    put<T>(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'response';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpResponse<T>>;
    put(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'response';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpResponse<string>>;
    put<T>(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'events';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpEvent<T>>;
    put(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'events';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpEvent<string>>;
    put<T>(url: string, body: any | null, options?: any): Observable<any> {
       if (this.debug) {
            console.warn('PUT request to:', url, 'with body:', body, 'and options:', options);
       }
        return this.http.put<T>(url, body, options);
    }

    delete<T>(url: string, options?: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe?: 'body';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<T>;
    delete(url: string, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe?: 'body';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<string>;
    delete<T>(url: string, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'response';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpResponse<T>>;
    delete(url: string, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'response';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpResponse<string>>;
    delete<T>(url: string, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'events';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpEvent<T>>;
    delete(url: string, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'events';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpEvent<string>>;
    delete<T>(url: string, options?: any): Observable<any> {
        if (this.debug) {
            console.warn('DELETE request to:', url, 'with options:', options);
        }
        return this.http.delete<T>(url, options);
    }

    patch<T>(url: string, body: any | null, options?: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe?: 'body';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<T>;
    patch(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe?: 'body';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<string>;
    patch<T>(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'response';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpResponse<T>>;
    patch(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'response';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpResponse<string>>;
    patch<T>(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'events';
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpEvent<T>>;
    patch(url: string, body: any | null, options: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        observe: 'events';
        reportProgress?: boolean;
        responseType: 'text';
        withCredentials?: boolean;
        context?: HttpContext;
    }): Observable<HttpEvent<string>>;
    patch<T>(url: string, body: any | null, options?: any): Observable<any> {
        if (this.debug) {
            console.warn('PATCH request to:', url, 'with body:', body, 'and options:', options);
        }
        return this.http.patch<T>(url, body, options);
    }
}
